import { useContext } from 'react';
import EnvironmentContext from '@/client/contexts/EnvironmentContext';

const useIsMarktplaats = (): boolean => {
  const { tenantContext } = useContext(EnvironmentContext);
  return tenantContext.tenant === 'mp';
};
export default useIsMarktplaats;
